import { useState } from 'react'
import styled from 'styled-components'

import { Button as Button_, useHapticFeedback } from '@blade/ui-kit'
import { SwapIcon } from '@root/shared/ui-kit'

type SwapInputProps = {
  onSwitchCurrencies: () => void
}

export const SwapInputSeparator: React.FC<SwapInputProps> = ({
  onSwitchCurrencies,
}) => {
  const haptics = useHapticFeedback()
  const [isRotated, setIsRotated] = useState(false)

  const handleSwitchCurrencies: React.MouseEventHandler<HTMLElement> = () => {
    haptics.impactOccurred('light')
    setIsRotated(!isRotated)
    onSwitchCurrencies()
  }

  return (
    <Root>
      <Button
        variant="solid"
        iconLeft={<SwapIcon />}
        size="h32"
        onClick={handleSwitchCurrencies}
        color="primary"
        data-rotated={isRotated}
      />
    </Root>
  )
}

const Root = styled.div``

const Button = styled(Button_)`
  position: absolute;
  top: calc(50% - 20px);
  left: calc(50% - 20px);
  z-index: 1;

  transform: rotate(0);
  transition: transform 0.15s ease-in-out;

  &[data-rotated='true'] {
    transform: rotate(180deg);
  }
`
